<div class="svg-icon" [innerHTML]="svgContent()"></div>
